import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  padding?: boolean;
}

export function Card({ children, className = '', onClick, padding = true }: Props) {
  const base = [
    'bg-white rounded-2xl shadow-sm border border-gray-100',
    padding ? 'p-4' : '',
    onClick ? 'cursor-pointer active:bg-gray-50 transition-colors' : '',
    className,
  ].join(' ');

  if (onClick) {
    return (
      <div role="button" tabIndex={0} className={base} onClick={onClick}
        onKeyDown={(e) => e.key === 'Enter' && onClick()}>
        {children}
      </div>
    );
  }

  return <div className={base}>{children}</div>;
}
